import request from "@/utils/request";

// 查询美育浸润信息
export const  gainMentalityUrl =(data) =>{
    return request({
        url: "/businessservice/mentality/gainMentalityUrl",
        method:"post",
        data: data
    })
}